<template lang="html">
  <div class="row">
    <div class="col-lg-12 lbv-leak-free-days">
      <b-card header="Leak-Free Days">
        <table class="table b-table">
          <thead>
            <th>Leak Free Days</th>
            <th>Fix Leak Days</th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in pagedCycles">
              <td>
                <table class="table b-table table-striped">
                  <thead>
                    <th>Start Date</th>
                    <th>Days</th>
                    <th>Paused</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ item.leakFreeDate }}</td>
                      <td>{{ item.leakFreeDays }}</td>
                      <td>{{ item.paused }}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td>
                <table class="table b-table table-striped">
                  <thead>
                    <th>Start Date</th>
                    <th>Days Remaining</th>
                    <th>Elapsed Days</th>
                  </thead>
                  <tbody>
                    <tr v-for="(fixDay, index) in item.fixDays">
                      <td>{{ fixDay.created }}</td>
                      <td>{{ fixDay.remaining }}</td>
                      <td>{{ fixDay.elapsed }}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          v-if="hasNextPage || pageNumber > 1"
          class="pagination col-lg-12"
        >
          <b-button
            class="page prev"
            variant="primary"
            size="sm"
            :disabled="pageNumber === 1"
            @click.prevent="page"
          >
            Prev
          </b-button>
          <div class="current-page">
            Page: {{ pageNumber }}
          </div>
          <b-button
            class="page next"
            variant="primary"
            size="sm"
            :disabled="!hasNextPage"
            @click.prevent="page"
          >
            Next
          </b-button>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../event-bus.js'
import { StatusBarEvent } from '../../events/statusBarEvent'
import { APIEvent } from '../../events/apiEvent'
import { TabNavEvent } from '../../events/tabNavEvent'

export default {
  name: 'LeakFreeView',
  data () {
    return {
      leakDayThreshold: 0,
      leakDaysAllowed: 0,
      currentDevice: {},
      leakCycles: {},
      pagedCycles: [],
      perPage: 3,
      pageNumber: 1,
      hasNextPage: false
    }
  },
  mounted () {
    EventBus.$on(TabNavEvent.LEAK_FREE, this.init)
  },
  destroyed () {
    EventBus.$off(TabNavEvent.LEAK_FREE)
  },
  methods: {
    init: function () {
      this.currentDevice = this.$store.state.currentDevice.Device
      let tenantList = this.$store.getters.tenantsList
      let tName = this.currentDevice.tenantName
      let tenantId = ''
      for (var i = 0; i < tenantList.length; i++) {
        if (tenantList[i].name === tName) {
          tenantId = tenantList[i].id
          break
        }
      }
      this.$store.dispatch(APIEvent.FETCH_TENANT, {tenant_id: tenantId})
        .then((response) => {
          if (typeof this.$store.state.currentDevice.leak_count_details !== 'undefined') {
            this.leakDaysAllowed = response.data.leak_daysAllowed
            this.leakDayThreshold = response.data.leak_days_threshold
            let leaks = this.$store.state.currentDevice.leak_count_details.record
            let orderedLeaks = leaks.sort(function (a, b) {
              return b.epoch - a.epoch
            })
            this.leakCycles = this.calculateLeakCycles(orderedLeaks, this.leakDayThreshold)
            if (this.leakCycles.leakFree.length > 0) {
              this.leakCycles.leakFree[0].paused =
                this.$store.state.currentDevice.leak_count_summary.paused === '1'
                  ? 'Y'
                  : 'N'
              this.leakCycles.leakFree[0].leakFreeDays = parseInt(this.$store.state.currentDevice.leak_count_summary.leak_free_days)
              if (typeof this.leakCycles.leakFix[0] !== 'undefined' && this.leakCycles.leakFree.length > 2) {
                for (var j = 1; j < this.leakCycles.leakFree.length; j++) {
                  let d1 = this.leakCycles.leakFree[j].leakFreeDate.split(' ')[0]
                  let d2 = this.leakCycles.leakFix[j - 1].slice(-1).pop().created.split(' ')[0]
                  this.leakCycles.leakFree[j].leakFreeDays = this.diffDays(d2, d1)
                }
              }
              for (var i = 0; i < this.leakCycles.leakFree.length; i++) {
                let cycle = this.leakCycles.leakFree[i]
                cycle.fixDays = this.leakCycles.leakFix[i]
              }
              this.pageCycles()
            }
          }
        })
        .catch(this.handleError)
    },
    pageCycles: function () {
      // create an index to start slice of master data
      let startPos = (this.pageNumber - 1) * this.perPage
      // create count of records to copy
      let endPos = (this.pageNumber * this.perPage)
      // use slice to make shallow copy of master data for use as 'page'
      this.pagedCycles = this.leakCycles.leakFree.slice(startPos, endPos)
      // if there are more records than allowed in
      // current page, set hasNextPage to true
      if (this.leakCycles.leakFree.length > this.perPage) {
        this.hasNextPage = true
      }
    },
    page: function (event) {
      var next = event.currentTarget.className.indexOf('next') > -1
      if (next) {
        // increment page number
        this.pageNumber++
        // determine if there are more records
        this.hasNextPage = this.leakCycles.leakFree.length > (this.pageNumber * this.perPage)
      } else {
        this.pageNumber--
        // if we reach here, there is always a next page
        this.hasNextPage = true
      }
      this.pageCycles()
    },
    handleError (error) {
      if (error.message !== "Cannot read property 'sort' of undefined") {
        EventBus.$emit(StatusBarEvent.ERROR, error.message)
      }
    },
    calculateLeakCycles: function (leaks, leakThreshold) {
      var leakFreeCycles = []
      var fixLeakCycles = []
      var currentFixCycle = []
      var leakFreeDate = ''
      var leakFreeDays = 0
      var grace = parseInt(leakThreshold)
      for (var i = 0; i < leaks.length; i++) {
        var cycle
        var currentLeak = leaks[i]
        if (i === 0 && currentLeak.code === 'LeakTrue') {
          leakFreeDate = currentLeak.created
          leakFreeDays = parseInt(this.$store.state.currentDevice.leak_count_summary.leak_free_days)
          if (this.$store.state.currentDevice.leak_count_summary.paused === 1) {
            this.paused = 'Y'
          }
          // why do we need to add to cycle for memory
          currentFixCycle.push(currentLeak)
          continue
        } // else {
        if (currentLeak.code === 'LeakTrue') {
          currentFixCycle.push(currentLeak)
          // check if current leak length exceeds grace period
          if (parseInt(currentLeak.days) <= grace) {
            // if not and last leak period is not set, use the close date of
            // current leak as the last leak free date
            // should this be derived from a leak true event? - JC
            leakFreeDate = leakFreeDate === '' ? currentLeak.closed : leakFreeDate
            // add to running total of leak free days because we are in grace
            leakFreeDays += parseInt(currentLeak.days)
          } else { // otherwise we are out of grace
            // create a new cycle
            cycle = {leakFreeDate: leakFreeDate, leakFreeDays: leakFreeDays}
            leakFreeCycles.push(cycle)
            fixLeakCycles.push(currentFixCycle)
            // reset everything because current cycle has ended
            leakFreeDate = ''
            leakFreeDays = 0
            currentFixCycle = []
            continue
          }
        } // else 2/05
        if (currentLeak.code === 'LeakFalse') {
          // set the last leak free date - this should override any
          // LeakTrue dates
          leakFreeDate = currentLeak.created
          if (leaks.length === 1 && currentLeak.closed === 'NULL') {
            leakFreeDays = parseInt(this.$store.state.currentDevice.leak_count_summary.leak_free_days)
          } else {
            // if leak was set to false today, no leak free days are set
            currentLeak.days = currentLeak.days === 'null' ? 0 : currentLeak.days
            // leakFreeDays += parseInt(currentLeak.days)
            // closed - created
            // if closed is set to NULL then closed is today date
            if (currentLeak.closed === 'NULL' || currentLeak.closed === 'null') {
              leakFreeDays = parseInt(this.$store.state.currentDevice.leak_count_summary.leak_free_days)
            }
          }
        }
        // Modification 2/05/2019
        if ((i === 0 && currentLeak.code === 'LeakFalse' && (currentLeak.closed === 'NULL' || currentLeak.closed === 'null')) &&
         (i === leaks.length - 1 && currentLeak.code === 'LeakTrue')) {
          leakFreeDays = parseInt(this.$store.state.currentDevice.leak_count_summary.leak_free_days)
        }
        // leakFreeDays = parseInt(this.$store.state.currentDevice.leak_count_summary.leak_free_days)
        this.paused =
          this.$store.state.currentDevice.leak_count_summary.paused === '1'
            ? 'Y'
            : 'N'
        leakFreeDate = currentLeak.created
        // End Modification 2/05/2019
        if (i === leaks.length - 1) {
          // make sure we add the last cycle to the array before we exit the loop
          cycle = {leakFreeDate: leakFreeDate, leakFreeDays: leakFreeDays}
          leakFreeCycles.push(cycle)
          fixLeakCycles.push(currentFixCycle)
        }
      //  }
      }
      fixLeakCycles = this.calculateFixLeakCycles(fixLeakCycles, grace)
      return {leakFree: leakFreeCycles, leakFix: fixLeakCycles}
    },
    // method to iterate through leak true events
    calculateFixLeakCycles: function (fixLeakCycles, grace) {
      var fixCycles = []
      // nested array so that we can pair up Leak Free periods with leak true events
      for (var i = 0; i < fixLeakCycles.length; i++) {
        var fixData = fixLeakCycles[i]
        var currentFixCycles = []
        for (var j = 0; j < fixData.length; j++) {
          var cycle = fixData[j]
          var fixCycle = {}
          // if currently in leakTrue
          if (cycle.days === 'null') {
            // calculate the days as they are not provided
            fixCycle = this.calculateFixLeakDays(cycle.epoch, grace)
            fixCycle.created = cycle.created
          } else {
            // cap the elapsed days to the grace period
            var currDays = parseInt(cycle.days)
            if (currDays > grace) {
              currDays = grace
            }
            fixCycle.elapsed = currDays
            // calculate remaining days by subtracting elapsed from grace
            fixCycle.remaining = grace - currDays
            fixCycle.created = cycle.created
          }
          currentFixCycles.push(fixCycle)
        }
        fixCycles.push(currentFixCycles)
      }
      return fixCycles
    },
    calculateFixLeakDays: function (lastLeakEpoch, graceDays) {
      var today = Math.floor(new Date().getTime() / 1000) // current day divided to get seconds
      var lastLeak = parseInt(lastLeakEpoch) // epoch of last leak
      var grace = graceDays * 86400 // leak grace multiplied by seconds in a day

      // graceDelta is the difference between (the last leak with the grace time added) and today's date
      // if todays date is less than this value user is in grace but we have a negative delta. To
      // normalize this, we multiply by -1
      var graceDelta = (((today - (lastLeak + grace)) * -1) / 86400)
      // we want to round towards zero not negative infinity
      graceDelta = graceDelta < 0 ? Math.ceil(graceDelta) : Math.floor(graceDelta)
      // create the results but limit to 0 rather than negative
      var elapsed = graceDelta < 0 ? graceDays : graceDelta
      var remaining = graceDays - elapsed
      return {elapsed: remaining, remaining: elapsed}
    },
    // Calculate the difference of two dates in total days
    diffDays: function (d1, d2) {
      let ndays
      d1 = d1.split('-')
      d2 = d2.split('-')

      // Now we convert the array to a Date object, which has several helpful methods
      d1 = new Date(d1[0], d1[1], d1[2])
      d2 = new Date(d2[0], d2[1], d2[2])

      let tv1 = d1.getTime()
      let tv2 = d2.getTime()

      ndays = (tv1 - tv2) / 1000 / 86400
      ndays = Math.round(ndays - 0.5)
      return ndays
    }
  }

}
</script>

<style lang="css">
  .pagination .current-page {
    margin-top: 15px;
  }
</style>
